var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 24,
    viewBox: "0 0 432 400",
    enableBackground: "new 0 0 432 400",
    xmlSpace: "preserve",
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: " M62.000324,352.030090  C99.486351,314.541595 136.674805,277.258789 174.029572,240.143372  C177.389984,236.804474 177.699371,234.607224 175.123001,230.516083  C145.959900,184.206375 147.541656,126.868240 180.065811,83.119324  C203.679047,51.356663 235.738068,33.695599 275.466949,30.634642  C338.609680,25.769737 392.341125,66.814240 409.391785,121.648491  C430.687469,190.134628 392.419891,264.013550 323.821045,285.014099  C285.275726,296.814209 248.726105,291.617188 214.635452,270.155701  C210.663651,267.655273 208.575134,268.182983 205.465881,271.313385  C168.241150,308.791351 130.918121,346.172028 93.524361,383.481476  C83.687309,393.296295 70.536232,393.531738 61.460888,384.465454  C52.335995,375.349640 52.453400,362.172913 62.000324,352.030090  M220.301620,83.795174  C192.048752,108.907143 180.422943,140.286636 186.311920,177.537979  C194.972565,232.321899 248.771164,269.645782 303.295471,259.283386  C350.833740,250.248672 384.649841,208.466629 385.127625,162.293808  C385.689362,108.014053 343.898224,62.819668 289.875946,60.358299  C263.984802,59.178650 240.987778,67.056168 220.301620,83.795174  z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: " M330.975677,89.938721  C334.947418,93.002426 338.737457,95.730423 342.251160,98.777115  C346.956116,102.856743 347.777466,108.351677 344.498657,111.826118  C341.159332,115.364662 336.651855,114.863739 331.821564,110.417290  C306.919739,87.494324 270.205780,85.633453 243.333633,105.981522  C241.086182,107.683334 239.111633,109.740852 236.945465,111.555748  C232.844467,114.991707 228.449692,115.037209 225.335464,111.748070  C222.261154,108.501083 222.466461,103.868752 226.228897,100.201073  C240.336441,86.448860 257.316467,78.734047 276.867523,76.765488  C296.286102,74.810265 314.162872,79.504929 330.975677,89.938721  z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.1879efa6b93886f3b675d288874b8d48.svg";
export { ForwardRef as ReactComponent };